export default function Component$toString () {
	return this.instance.fragment.toString();
}
